import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CONTACT } from '../data';
import './Header.css';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/#services' },
  { label: 'Case Studies', path: '/#case-studies' },
  { label: 'Contact', path: '/#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const usesDarkHeader = location.pathname.startsWith('/services/');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (path) => {
    setMenuOpen(false);
    if (path.startsWith('/#')) {
      const id = path.slice(2);
      if (location.pathname !== '/') {
        // Navigate to home then scroll
        window.location.href = path;
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className={`header ${usesDarkHeader ? 'header--dark' : ''} ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="header__inner container">
        <Link to="/" className="header__brand">
          <span className="header__brand-mark">
            <span className="header__brand-xbc">XBC</span>
            <span className="header__brand-solutions">Solutions</span>
          </span>
        </Link>

        <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
          {NAV_LINKS.map(link => (
            link.path.startsWith('/#') ? (
              <button
                key={link.label}
                className="header__nav-link"
                onClick={() => handleNavClick(link.path)}
              >
                {link.label}
              </button>
            ) : (
              <Link
                key={link.label}
                to={link.path}
                className="header__nav-link"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </Link>
            )
          ))}
          <a
            href={`mailto:${CONTACT.email}`}
            className="header__cta"
          >
            Get in Touch
          </a>
        </nav>

        <button
          className={`header__hamburger ${menuOpen ? 'header__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
